import { StateCreator } from "zustand";
import { TokenData } from "../../../domain/models/token-data";
import jwt_decode from "jwt-decode";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY } from "../../../base";
import { UserDetails } from "../../../domain/models/uset-details";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { RemoteFetchUserDetails } from "../../../data/usecases/remote-fetch-user-details";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";


export interface selectedCustomerSlice {
  customerIds: number[];
  headquarterIds: number[];
  mappingIds: number[];
  selectedPanel: boolean;
  handleSelectedPanel: Function;
  panelName: string;
  handleSelectedCustomers: Function;
  handleSelectedCustomersMappingIds: Function;
  handleClearSelectedCustomers: Function;
  handleSelectedHeadquarterIds: Function;
  userRole: TokenData;
  decodeToken: Function;
  userDetails: UserDetails;
  userDetailsStatus: FetchState;
  userLogDetails: UserDetails;
  getUserDetails: Function;
  currentPageNumber: number;
  handlePageNumber: Function;
  headquarterCode: string;
  handleHeadquarterCode: Function;
}

const initialStates = {
  customerIds: [],
  mappingIds: [],
  selectedPanel: false,
  userRole: {} as TokenData,
  userDetails: {} as UserDetails,
  userLogDetails: {} as UserDetails,
  panelName: "All",
  currentPageNumber: 1,
  userDetailsStatus: FetchState.DEFAULT,
  headquarterCode: "",
  headquarterIds: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useSelectedCustomerSlice: StateCreator<selectedCustomerSlice> = (
  set,
  get
) => ({
  ...initialStates,
  handleSelectedPanel: (value: boolean, name: string) => {
    set(() => ({ selectedPanel: value }));
    set(() => ({ panelName: name }));
  },

  handleSelectedCustomers: (value: number[]) => {
    set(() => ({ customerIds: value }));
  },
  handleSelectedCustomersMappingIds: (value: number[]) => {
    set(() => ({ mappingIds: value }));
  },
  handleHeadquarterCode: (value: string) => {
    set(() => ({ headquarterCode: value }));
  },
  handleSelectedHeadquarterIds: (value: number[]) => {
    set(() => ({ headquarterIds: value }));
  },
  handleClearSelectedCustomers: () => {
    set(() => ({ customerIds: [] }));
    set(() => ({ mappingIds: [] }));
    set(() => ({ headquarterIds: [] }));
  },

  decodeToken: () => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    if (token) {
      let decoded: TokenData = jwt_decode(token.toString());
      set(() => ({ userRole: decoded }));
      get().getUserDetails();
    }
  },

  getUserDetails: async () => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";

    set(() => ({ userDetailsStatus: FetchState.LOADING }));

    const BASE_URL = getDataKeyFromLocalStorage("baseUrl") ?? "";

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchUserDetails = new RemoteFetchUserDetails(
      `${BASE_URL}${Endpoints.FETCH_USER_DETAILS}`,
      axiosHttpClient
    );

    let result = await remoteFetchUserDetails.get();
    if (result) {
      set(() => ({
        userDetails: result.user,
        userDetailsStatus: FetchState.SUCCESS,
      }));
    }
  },
  handlePageNumber: (pageNo: number) => {
    set(() => ({ currentPageNumber: pageNo }));
  },
});
